// @flow

import React, { type Node } from 'react';

import { getImplementedTraits } from '@tectonics/look-and-feel';
import laf from '@tectonics/look-and-feel/shopify';
import { useAllFeatures } from '@tectonics/prs/payment-spec';
import pagofacilIconSrc from './cash-pagofacil.svg';
import rapipagoIconSrc from './cash-rapipago.svg';
import { Icon, IconWrapper, BrandsIconsWrapper } from '../../../../../../../../commons/atoms';
import { compareBankOptionsOrder } from '@tectonics/prs/argentina';

export function DisplayArgentineCashBrand(): Node {
  const allFeatures = useAllFeatures();
  const bankList = [
    ...getImplementedTraits(laf, 'field_argentine_cash_bank_list',  allFeatures),
  ].sort(compareBankOptionsOrder);
  return (
    <BrandsIconsWrapper>
      {bankList.map(code =>
        <IconWrapper key={code}>
          <Icon src={getCashOptionIconSrc(code)} alt={code} />
        </IconWrapper>
      )}
    </BrandsIconsWrapper>
  );
}

function getCashOptionIconSrc(code: string): string {
  switch (code) {
    case 'pagofacil':
      return pagofacilIconSrc;
    case 'rapipago':
      return rapipagoIconSrc;
    default:
      throw new Error(`Bank option "${code}" not supported`);
  }
}
